module.exports = __webpack_public_path__ + "img/warning.77072f53.svg";